import { Product, ProductUnit } from "@/@core/entity/product.entity";
import { BaseResAPI } from "@/@core/entity/res-api.entity";
import { StockID } from "@/@core/entity/stock.entity";
import { Warehouse } from "@/@core/entity/warehouse.entity";
import api from "@/api/axios";

export interface GetStockDetail {
  stockId: StockID;
  serial_number: string;
}

export interface StockDetailData {
  product: Product;
  warehouse_source?: Warehouse;
  warehouse_target?: Warehouse;
  product_unit: ProductUnit[];
}
export type GetStockDetailResp = BaseResAPI<StockDetailData>;

const getStockDetailInteractor = (
  params: GetStockDetail
): Promise<GetStockDetailResp> => {
  const { stockId } = params;
  let pathParam = "?";
  if (params.serial_number != "") pathParam += `&serial_number=${params.serial_number}`;
  const basePath = `/admin/stock/${stockId}`;
  const path = pathParam === "?" ? basePath : basePath + pathParam ;
  return api.get(path);
};

export default getStockDetailInteractor;
